const useAuthCandidateToken = () => {
    const candidateToken = localStorage.getItem("candidate.token") || null
    return {candidateToken}
  }
  
  export default useAuthCandidateToken